import {imageDesserts} from "../Desserts/ImageDesserts";

export const deserts = [

    {
        id: 61,
        img: imageDesserts.Mishel,
        title: 'МИШЕЛЬ',
        structure: 'ЯПОНСКОЕ ТЕСТО,ПАСТА ШОКОЛАДНАЯ,КЛУБНИКА КОНСЕРВ.,ТОППИНГ ШОКОЛАДНЫЙ,КРЕКЕР.',
        price: '205',
        count: '6',
        weight: '190',
    }
    ,
    {
        id: 62,
        img: imageDesserts.citron,
        title: 'ЦИТРОН',
        structure: 'ЯПОНСКОЕ ТЕСТО,СЫР СЛИВОЧНЫЙ,КЛУБНИКА,КИВИ,ТОППИНГ КЛУБНИЧНЫЙ.',
        price: '205',
        count: '6',
        weight: '190',
    }
    ,
    {
        id: 63,
        img: imageDesserts.tropicana,
        title: 'ТРОПИКАНА',
        structure: 'ЯПОНСКОЕ ТЕСТО,СЛИВОЧНЫЙ СЫР,ЯБЛОКО,БАНАН,КИВИ,МЁД,САХАРНАЯ ПУДРА.',
        price: '205',
        count: '6',
        weight: '190',
    }
    ,
    {
        id: 64,
        img: imageDesserts.hipHop,
        title: 'ХИП ХОП',
        structure: 'ЯПОНСКОЕ ТЕСТО,СЛИВОЧНЫЙ СЫР,БАНАН,АНАНАС КОНСЕРВИРОВАННЫЙ ,АПЕЛЬСИН,ТОПИНГ ШОКОЛАДНЫЙ,КОКОСОВАЯ СТРУЖКА.\n',
        price: '205',
        count: '6',
        weight: '190',
    },
]